import { format } from "date-fns";
import { de } from "date-fns/locale";

import { cn } from "@/lib/cn";
import { Row, type RowData } from "@tanstack/react-table";

interface DatatableCellDateProps<TData extends RowData> {
  row: Row<TData>;
  className?: string;
  icon?: React.ReactNode;
  date: string | null | undefined;
}

export const DatatableCellDate = <TData extends RowData>({ className, icon, date }: DatatableCellDateProps<TData>) => {
  return (
    <div className={cn(["relative flex h-full flex-row items-center justify-start gap-1 font-normal", className])}>
      <div className="flex w-full flex-row items-center justify-start gap-2 whitespace-nowrap pl-2 pr-8 text-muted-foreground">
        {date && (
          <>
            {icon && icon}
            <span className="whitespace-nowrap">
              {(() => {
                try {
                  return format(new Date(date), "PPP", { locale: de });
                } catch (error) {
                  console.error("Invalid date format:", error);
                  return "Invalid date";
                }
              })()}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
